export class SavedVariationState {
    constructor() {
        this.selectionId = null;
        this.variationSettings = null;
    }
    peek() {
        if (this.selectionId === null) {
            return null;
        }
        return {
            selectionId: this.selectionId,
            variationSettings: this.variationSettings
                ? { ...this.variationSettings }
                : null
        };
    }
    hasSavedState() {
        return this.selectionId !== null;
    }
    matchesCurrent(selectionId) {
        return this.selectionId !== null && this.selectionId === selectionId;
    }
    save(selectionId, variationSettings) {
        if (selectionId === null) {
            return false;
        }
        if (this.selectionId === selectionId) {
            return false;
        }
        this.selectionId = selectionId;
        this.variationSettings = { ...variationSettings };
        return true;
    }
    sync(selectionId, variationSettings) {
        if (selectionId === null || variationSettings === null) {
            this.clear();
            return;
        }
        this.selectionId = selectionId;
        this.variationSettings = { ...variationSettings };
    }
    clear() {
        this.selectionId = null;
        this.variationSettings = null;
    }
    consume() {
        const snapshot = this.peek();
        this.clear();
        return snapshot;
    }
}
